(function () {
  var clarityLoaded = false;
  var clarityProjectId = "y7sxw18fb4";

  function loadClarity(marketingAllowed) {
    if (clarityLoaded) return;
    clarityLoaded = true;

    window.clarity = window.clarity || function () {
      (window.clarity.q = window.clarity.q || []).push(arguments);
    };

    var script = document.createElement("script");
    script.async = true;
    script.src = "https://www.clarity.ms/tag/" + clarityProjectId;

    var firstScript = document.getElementsByTagName("script")[0];
    firstScript.parentNode.insertBefore(script, firstScript);

    window.clarity("consentv2", {
      analytics_Storage: "granted",
      ad_Storage: marketingAllowed ? "granted" : "denied"
    });
  }

  function updateClarityConsent(analyticsAllowed, marketingAllowed) {
    if (analyticsAllowed) {
      loadClarity(marketingAllowed);

      if (clarityLoaded) {
        window.clarity("consentv2", {
          analytics_Storage: "granted",
          ad_Storage: marketingAllowed ? "granted" : "denied"
        });
      }
    } else if (clarityLoaded && window.clarity) {
      window.clarity("consentv2", {
        analytics_Storage: "denied",
        ad_Storage: "denied"
      });

      window.clarity("consent", false);
    }
  }

  document.addEventListener("visitorConsentCollected", function (event) {
    updateClarityConsent(
      event.detail.analyticsAllowed,
      event.detail.marketingAllowed
    );
  });

  if (window.Shopify && Shopify.loadFeatures) {
    Shopify.loadFeatures(
      [{
        name: "consent-tracking-api",
        version: "0.1"
      }],
      function (error) {
        if (
          !error &&
          Shopify.customerPrivacy
        ) {
var consent = Shopify.customerPrivacy.currentVisitorConsent();

updateClarityConsent(
  consent.analytics === "yes",
  consent.marketing === "yes"
);
        }
      }
    );
  }
})();
